import React from "react";
import "../styles/footer.css";

const Footer = () => {
  return (
    <footer className="footer text-center pb-4">
      <div className="fs-5">
        <a
          href="https://www.linkedin.com/in/lutfinurilanwar/"
          className="social-media"
        >
          <i className="bi bi-linkedin"></i>
        </a>
        <a href="https://github.com/lutfianwr" className="social-media">
          <i className="bi bi-github"></i>
        </a>
        <a href="https://www.instagram.com/nrlltf" className="social-media">
          <i className="bi bi-instagram"></i>
        </a>
        <a href="mailto:lutfi.nurilanwar@gmail.com" className="social-media">
          <i className="bi bi-envelope-fill"></i>
        </a>
      </div>
      <p className="mb-0 mt-2 opacity-75">Lutfi Nuril Anwar</p>
      <p className="fw-light mb-0 opacity-50">@2022 all right reserved</p>
    </footer>
  );
};

export default Footer;
